/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  OnChainPixelArt,
  OnChainPixelArtInterface,
} from "../OnChainPixelArt";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "base64Encode",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "layer1",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "layer2",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "totalPixels",
        type: "uint256",
      },
    ],
    name: "composeLayers",
    outputs: [
      {
        internalType: "uint256[]",
        name: "comp",
        type: "uint256[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "palette1",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "palette2",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "colorCount1",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "colorCount2",
        type: "uint256",
      },
    ],
    name: "composePalettes",
    outputs: [
      {
        internalType: "uint256[]",
        name: "composedPalette",
        type: "uint256[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "colors",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "pixelCompression",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "colorCount",
        type: "uint256",
      },
    ],
    name: "encodeColorArray",
    outputs: [
      {
        internalType: "uint256[]",
        name: "encoded",
        type: "uint256[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "layers",
        type: "uint256[]",
      },
    ],
    name: "getColorCount",
    outputs: [
      {
        internalType: "uint256",
        name: "colorCount",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "canvas",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "palette",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "xDim",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "yDim",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "svgExtension",
        type: "string",
      },
    ],
    name: "render",
    outputs: [
      {
        internalType: "string",
        name: "svg",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "toHexString",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "toString",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "data",
        type: "string",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "encoded",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "data",
        type: "string",
      },
    ],
    name: "uriSvg",
    outputs: [
      {
        internalType: "string",
        name: "encoded",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50610cc0806100206000396000f3fe608060405234801561001057600080fd5b506004361061009d5760003560e01c80638fba8d5c116100665780638fba8d5c14610124578063a5ba1e4014610137578063c19728641461014a578063d5fb1b191461016b578063e89cec8f1461017e57600080fd5b80624aaa15146100a25780630de72b7e146100cb5780635b2125fa146100eb5780635bab8bda146100fe5780636900a3ae14610111575b600080fd5b6100b56100b0366004610740565b610191565b6040516100c29190610a8b565b60405180910390f35b6100de6100d9366004610945565b610229565b6040516100c29190610bb4565b6100b56100f93660046107aa565b6102bd565b6100b561010c3660046108b3565b61035a565b6100de61011f3660046109e2565b610398565b6100de6101323660046109e2565b6103d3565b6100de61014536600461081b565b61040e565b61015d61015836600461067a565b6104ae565b6040519081526020016100c2565b6100de6101793660046108ff565b610538565b6100de61018c366004610945565b610572565b604051624aaa1560e01b815260609073__$2e286f769ee588d09b231b39a8f53392dc$__90624aaa15906101cd90879087908790600401610acf565b60006040518083038186803b1580156101e557600080fd5b505af41580156101f9573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261022191908101906106ad565b949350505050565b6040516306f395bf60e11b815260609073__$2e286f769ee588d09b231b39a8f53392dc$__90630de72b7e90610263908590600401610bb4565b60006040518083038186803b15801561027b57600080fd5b505af415801561028f573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526102b79190810190610978565b92915050565b604051632d9092fd60e11b815260609073__$2e286f769ee588d09b231b39a8f53392dc$__90635b2125fa906102fd908890889088908890600401610b05565b60006040518083038186803b15801561031557600080fd5b505af4158015610329573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261035191908101906106ad565b95945050505050565b604051632dd5c5ed60e11b815260609073__$2e286f769ee588d09b231b39a8f53392dc$__90635bab8bda906101cd90879087908790600401610b8f565b60405163348051d760e11b81526004810182905260609073__$2e286f769ee588d09b231b39a8f53392dc$__90636900a3ae90602401610263565b6040516323eea35760e21b81526004810182905260609073__$2e286f769ee588d09b231b39a8f53392dc$__90638fba8d5c90602401610263565b604051630296e87960e61b815260609073__$2e286f769ee588d09b231b39a8f53392dc$__9063a5ba1e40906104509089908990899089908990600401610b3e565b60006040518083038186803b15801561046857600080fd5b505af415801561047c573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526104a49190810190610978565b9695505050505050565b604051633065ca1960e21b815260009073__$2e286f769ee588d09b231b39a8f53392dc$__9063c1972864906104e8908590600401610a78565b60206040518083038186803b15801561050057600080fd5b505af4158015610514573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906102b791906109fa565b60405163d5fb1b1960e01b815260609073__$2e286f769ee588d09b231b39a8f53392dc$__9063d5fb1b1990610263908590600401610bb4565b60405163e89cec8f60e01b815260609073__$2e286f769ee588d09b231b39a8f53392dc$__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";

type OnChainPixelArtConstructorParams =
  | [linkLibraryAddresses: OnChainPixelArtLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: OnChainPixelArtConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class OnChainPixelArt__factory extends ContractFactory {
  constructor(...args: OnChainPixelArtConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(
        _abi,
        OnChainPixelArt__factory.linkBytecode(linkLibraryAddresses),
        signer
      );
    }
  }

  static linkBytecode(
    linkLibraryAddresses: OnChainPixelArtLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$2e286f769ee588d09b231b39a8f53392dc\\$__", "g"),
      linkLibraryAddresses[
        "contracts/OnChainPixelArtLibrary.sol:OnChainPixelArtLibrary"
      ]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<OnChainPixelArt> {
    return super.deploy(overrides || {}) as Promise<OnChainPixelArt>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): OnChainPixelArt {
    return super.attach(address) as OnChainPixelArt;
  }
  connect(signer: Signer): OnChainPixelArt__factory {
    return super.connect(signer) as OnChainPixelArt__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): OnChainPixelArtInterface {
    return new utils.Interface(_abi) as OnChainPixelArtInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OnChainPixelArt {
    return new Contract(address, _abi, signerOrProvider) as OnChainPixelArt;
  }
}

export interface OnChainPixelArtLibraryAddresses {
  ["contracts/OnChainPixelArtLibrary.sol:OnChainPixelArtLibrary"]: string;
}
